import { BaseTheme, Theme } from '@dotcom/crown-ui';
import { buttons } from './buttons';
import { colors } from './colors';

export const ukTheme: Theme = {
  ...BaseTheme,
  button: {
    ...BaseTheme.button,
    primary: {
      ...BaseTheme.button.primary,
      background: buttons.primaryButtonBackgroundColor,
      color: buttons.primaryButtonTextColor,
      border: {
        color: buttons.primaryButtonBorderColor,
        width: buttons.primaryButtonBorderWidth,
      },
      hover: {
        background: buttons.primaryButtonHoverBackgroundColor,
        color: buttons.primaryButtonHoverTextColor,
        border: {
          color: buttons.primaryButtonHoverBorderColor,
          width: buttons.primaryButtonBorderWidth,
        },
      },
    },
    secondary: {
      ...BaseTheme.button.secondary,
      background: buttons.secondaryButtonBackgroundColor,
      color: buttons.secondaryButtonTextColor,
      border: {
        color: buttons.secondaryButtonBorderColor,
        width: buttons.secondaryButtonBorderWidth,
      },
      hover: {
        background: buttons.secondaryButtonHoverBackgroundColor,
        color: buttons.secondaryButtonHoverTextColor,
        border: {
          color: buttons.secondaryButtonHoverBorderColor,
          width: buttons.secondaryButtonBorderWidth,
        },
      },
    },
    tertiary: {
      ...BaseTheme.button.tertiary,
      background: buttons.tertiaryButtonBackgroundColor,
      color: buttons.tertiaryButtonTextColor,
      border: {
        color: buttons.tertiaryButtonBorderColor,
        width: buttons.secondaryButtonBorderWidth,
        type: buttons.teriaryButtonBorderType,
      },
      hover: {
        background: buttons.tertiaryButtonHoverBackgroundColor,
        color: buttons.tertiaryButtonHoverTextColor,
        border: {
          color: buttons.tertiaryButtonHoverBorderColor,
          width: buttons.secondaryButtonBorderWidth,
          type: buttons.teriaryButtonBorderType,
        },
        shadow: buttons.tertiaryButtonHoverBoxShadow,
      },
    },
    link: {
      ...BaseTheme.button.link,
      color: buttons.linkButtonColor,
      textDecoration: 'underline',
      hover: {
        color: buttons.linkButtonColor,
        textDecoration: 'underline',
      },
    },
    text: {
      ...BaseTheme.button.text,
      color: buttons.textButtonColor,
      hover: {
        color: buttons.textButtonColor,
      },
    },
  },
  color: {
    ...BaseTheme.color,
    palette: {
      ...BaseTheme.color.palette,
      primary: colors.palettePrimary,
      secondary: colors.paletteSecondary,
    },
    primary: {
      ...BaseTheme.color.primary,
      purple: colors.primaryPurple,
      lightPurple: colors.primaryLightPurple,
    },
  },
};
